// /* tslint:disable: max-classes-per-file */
import { createAction, props } from '@ngrx/store';

import { StateActiveIngredientSetting } from '../../activeingredientsetting.model';

export const loadActiveIngredientSettingsRequest = createAction(
  '[ActiveIngredientSettings] Load ActiveIngredientSettings request',
);

export const loadActiveIngredientSettingsSuccess = createAction(
  '[ActiveIngredientSettings] Load ActiveIngredientSettings success',
  props<{ activeIngredientSettings: StateActiveIngredientSetting[] }>(),
);

export const addActiveIngredientSetting = createAction(
  '[ActiveIngredientSettings] Add ActiveIngredientSetting',
);

export const editActiveIngredientSetting = createAction(
  '[ActiveIngredientSettings] Edit ActiveIngredientSetting',
  props<{ activeIngredientSetting: StateActiveIngredientSetting }>(),
);

export const deleteActiveIngredientSetting = createAction(
  '[ActiveIngredientSettings] Delete ActiveIngredientSetting',
  props<{ activeIngredientSetting: StateActiveIngredientSetting }>(),
);

export const upsertActiveIngredientSettings = createAction(
  '[ActiveIngredientSettings] Upsert ActiveIngredientSetting',
  props<{ activeIngredientSetting: StateActiveIngredientSetting }>(),
);
